import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddUpdateCommunicationComponent } from '../add-update-communication/add-update-communication.component';
import { Communication } from 'src/app/Modules/settings/models/profile/communication.model';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-communication-dropdown',
    templateUrl: './communication-dropdown.component.html',
    styleUrls: ['./communication-dropdown.component.scss'],
})
export class CommunicationDropdownComponent {
    datePipe = new DatePipe('en');
    constructor(
        private ngbModal: NgbModal,
        private managementService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService,
        private globalEmitterService: GlobalEmittersService,
        private customToastService: CustomToastService,
        private transLocoService: TranslocoService
    ) {}

    // * helper method to add general notification
    generalNotificationAdd(): void {
        const dialogRef = this.ngbModal.open(AddUpdateCommunicationComponent, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.communication = null;
        dialogRef.componentInstance.isGeneralNotification = true;
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.saveCustomNotifications([res]);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * helper method to add maintenance notification
    maintenanceNotificationAdd(): void {
        const dialogRef = this.ngbModal.open(AddUpdateCommunicationComponent, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.communication = null;
        dialogRef.componentInstance.isGeneralNotification = false;
        dialogRef.result
            .then((res) => {
                if (res) {
                    this.saveSystemMaintenanceNotification([res]);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * api call to save the system maintenance notification
    saveSystemMaintenanceNotification(systemNotification: Communication[]): void {
        let payload = [];
        this.ngxUiLoaderService.start();

        const getNotificationTypeIndex = (notificationTypes: number[]) => {
            switch (notificationTypes.length) {
                case 1:
                    return notificationTypes[0];
                case 2:
                    let result;
                    if (notificationTypes[0] + notificationTypes[1] === 3) {
                        result = 3;
                    } else if (notificationTypes[0] + notificationTypes[1] === 5) {
                        result = 5;
                    } else if (notificationTypes[0] + notificationTypes[1] === 6) {
                        result = 6;
                    }
                    return result;
                case 3:
                    return 7;
            }
        };

        payload = systemNotification.map((item) => {
            let placeholderObj = {
                startdate: `${new Date(item.systemStartDate).toISOString().replace('T', ' ').substring(0, 19)} UTC`,
                enddate: `${new Date(item.systemEndDate).toISOString().replace('T', ' ').substring(0, 19)} UTC`,
            };
            if (item.startDate) {
                return {
                    notificationCheckType: 5,
                    notificationTypeIndex: getNotificationTypeIndex(item.notificationTypes),
                    placeholder: JSON.stringify(placeholderObj),
                    startDate: this.datePipe.transform(item.startDate, 'MM/dd/yyyy'),
                    endDate: this.datePipe.transform(item.endDate, 'MM/dd/yyyy'),
                };
            } else {
                return {
                    notificationCheckType: 5,
                    notificationTypeIndex: getNotificationTypeIndex(item.notificationTypes),
                    placeholder: JSON.stringify(placeholderObj),
                };
            }
        });

        this.managementService.saveSystemMaintenanceNotification(payload).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    // this.profileForm.get('communication').reset();
                    // this.isSystemNotificationSaved = true;
                    // this.communicationToBeSaved = [];
                    this.customToastService.successToast(
                        this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_SAVED_SUCCESSFULLY'),
                        'Success'
                    );
                    this.globalEmitterService.getCommunicationListSubject.next(true);
                } else if (res.isCustom) {
                    this.userUtilityService.errorModelPopup(res.message);
                }
            },
            (err) => this.ngxUiLoaderService.stop()
        );
    }

    // * api call to save custom notifications
    saveCustomNotifications(customNotification: Communication[]): void {
        // * formate the date
        customNotification.forEach((res) => {
            const startDatePipe = new DatePipe('en');
            const endDatePipe = new DatePipe('en');
            res.startDate = startDatePipe.transform(res.startDate, 'MM/dd/yyyy');
            res.endDate = endDatePipe.transform(res.endDate, 'MM/dd/yyyy');
        });
        this.ngxUiLoaderService.start();
        this.managementService.saveCommunication(customNotification).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    this.customToastService.successToast(
                        this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_SAVED_SUCCESSFULLY'),
                        'Success'
                    );

                    this.globalEmitterService.getCommunicationListSubject.next(true);
                } else if (res.isCustom) {
                    this.userUtilityService.errorModelPopup(res.message);
                }
            },
            (err) => this.ngxUiLoaderService.stop()
        );
    }
}
